import { Spinner } from "@material-tailwind/react";
import ClientReservationDetailedCard from "components/ClientReservationCard/ClientReservationDetailedCard";
import ReservationsDetailedCard from "components/FlightCard/ReservationsDetailedCard";
import Heading2 from "components/Heading/Heading2";
import { AuthContext } from "context/appContext";
import { Reservation } from "data/types";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { FC, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  fetchReservationByOwner,
  fetchReservationByOwnerAsClient,
} from "redux/features/reservations/reservationSlice";
import Pagination from "shared/Pagination/Pagination";

export interface SectionGridFilterCardProps {
  className?: string;
}

const MadeReservationGridDetailedCard: FC<SectionGridFilterCardProps> = ({ className = "" }) => {
  const authContext = useContext(AuthContext);
  const [loading, setIsLoading] = useState(false);
  const profilId = authContext?.user?.profil?.id;
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch = useAppDispatch();
  let reservationState: Reservation[] = useAppSelector((state) => state.featureReservation.reservations);
  let totalPages = useAppSelector((state) => state.featureReservation.totalPages);
  let totalCount = useAppSelector((state) => state.featureReservation.totalCount);
  let reservationStateOwner: Reservation[] = useAppSelector((state) => state.featureReservation.reservationOwner);

  const location = useLocation();

  useEffect(() => {
    if (profilId) {
      switch (location.pathname) {
        case "/client/mes-reservations":
          setIsLoading(true);
          dispatch(fetchReservationByOwner({ id: profilId, page: currentPage })).finally(() =>
            setIsLoading(false)
          );
          break;
        case "/client/mes-evenements":
          setIsLoading(true);
          dispatch(fetchReservationByOwnerAsClient({ id: profilId, page: currentPage })).finally(() =>
            setIsLoading(false)
          );
          break;
        default:
          break;
      }
    }
  }, [profilId, currentPage, location.pathname]);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className={`nc-SectionGridFilterCard ${className}`} data-nc-id="SectionGridFilterCard">
      <div className="grid grid-cols-1 gap-6 rounded-3xl ">
        <Heading2
          heading={`${location.pathname === "/client/mes-reservations" ? "Mes réservations" : " Mes événements"}`}
          subHeading={
            <span className="block mt-3 text-neutral-500 dark:text-white">
              {totalCount} {`${location.pathname === "/client/mes-reservations" ? "réservations" : "événements"}`}
            </span>
          }
        />
        {loading ? (
          <div className="flex items-center justify-center mt-16 mb-2">
            <p>
              <Spinner color="blue" className="w-12 h-12" />
            </p>
          </div>
        ) : totalCount === 0 ? (
          <div className="flex items-center justify-center mt-16">
            <p>Pas de reservations disponibles</p>
          </div>
        ) : location.pathname === "/client/mes-reservations" ? (
          reservationState.map((item, index) => (
            <ReservationsDetailedCard defaultOpen={!index} key={index} data={item} totalCount={totalCount} />
          ))
        ) : location.pathname === "/client/mes-evenements" ? (
          reservationStateOwner?.length > 0 &&
          reservationStateOwner?.map((item, index) => (
            <ClientReservationDetailedCard defaultOpen={!index} key={index} data={item} totalCount={totalCount} />
          ))
        ) : null}
        <div className="flex items-center justify-center mt-16">
          {totalPages > 1 && !loading && (
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
          )}
        </div>
      </div>
    </div>
  );
};

export default MadeReservationGridDetailedCard;
